import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";

@Injectable()
export abstract class RestAbstractService {

    abstract get<Object>(url: string, queryString?: any, body?: any, header?: any): Observable<any>;

    abstract put<Object>(url: string, queryString?: any, body?: any, header?: any): Observable<any>;

    abstract post<Object>(url: string, queryString?: any, body?: any, header?: any): Observable<any>;

    abstract delete<Object>(url: string, queryString?: any, body?: any, header?: any): Observable<any>;

    abstract download(url: string, type: string, queryString?: any, body?: any, header?: any): Observable<any>;

}